import { CODE_GROUP_ID } from '../constant/Constant';
import CodeUtil from './CodeUtil';

class SemesterUtil {
    static convertSemesterNm(semesterId) {
        var semesterYear = semesterId.split('-')[0];
        var semesterType = semesterId.split('-')[1];
        return (
            CodeUtil.getCodeName(CODE_GROUP_ID.SEMESTER_YEAR, semesterYear) +
            ' ' +
            CodeUtil.getCodeName(CODE_GROUP_ID.SEMESTER_TYPE, semesterType)
        );
    }
}

export default SemesterUtil;
